import { h } from 'preact'
import style from './styles'

import Container from '../Container'
import Location from './Location'

const Header = () => (
  <div class={style.normal}>
    <Container class={style.inner}>
      <Location />
    </Container>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./components/Header/index.js